// @ commons
const { APIGet } = require('utilities/APIRequestHelper');

// @ utilities
const { base64ToBlob } = require('utilities/APIRequestHelper');
const BrowserUtils = require('utilities/browserUtils');

// @ constants
const {
    MORTGAGE_REQUEST_ASSET_FILE_RESET,
    MORTGAGE_REQUEST_ASSET_FILE_REQUEST,
    MORTGAGE_REQUEST_ASSET_FILE_SUCCESS,
    MORTGAGE_REQUEST_ASSET_FILE_FAILURE
} = require('constants/actionTypes');

const requestFetchAssetFileInProgress = () => ({
    type: MORTGAGE_REQUEST_ASSET_FILE_REQUEST
});

const requestFetchAssetFileSuccess = (dataBase64, contentType) => ({
    type: MORTGAGE_REQUEST_ASSET_FILE_SUCCESS,
    data: {
        dataBase64,
        contentType
    }
});

const requestFetchAssetFileFailure = error => ({
    type: MORTGAGE_REQUEST_ASSET_FILE_FAILURE,
    data: { error }
});

const requestResetState = () => ({
    type: MORTGAGE_REQUEST_ASSET_FILE_RESET
});

const resetState = () => dispatch => {
    dispatch(requestResetState());
}

const printAsset = () => (dispatch, getState) => {
    const currentState = getState().mortgageRequestAssets;

    if (currentState.get('isFetched')) {
        const data = [ base64ToBlob(currentState.get('file')) ];

        const blobObject = new Blob(data, {type: currentState.get('contentType')});

        if (BrowserUtils.browserIsIE()) {
            window.navigator.msSaveOrOpenBlob(blobObject);
        } else {
            const blobURL = window.URL.createObjectURL(blobObject);
            const winparams = 'dependent=yes,locationbar=no,scrollbars=yes,menubar=yes,'+
                              'resizable,screenX=50,screenY=50,width=850,height=1050';
            const printWindow = window.open(blobURL, '', winparams);
            printWindow.print();
        }
    }
};

const getAsset = (asset, print = false) => (dispatch, getState) => {
    const currentState = getState().mortgageRequestAssets;

    if (!currentState.get('isFetched') && !currentState.get('isFetching')) {
        dispatch(requestFetchAssetFileInProgress());

        const requestData = {
            query: {
              assetType: asset
            }
        }
        return APIGet({
            dispatch,
            endpoint: 'mortgageRequestAssets',
            params: requestData
        })
        .then(response => {
            const base64string = `data:${response.data.contentType};base64,${response.data.base64}`;
            dispatch(requestFetchAssetFileSuccess(base64string, response.data.contentType));
            print && printAsset()(dispatch, getState);
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(requestFetchAssetFileFailure(response.error))
            } else {
                throw response
            }
        });
    } else if (currentState.get('isFetched')) {
        print && printAsset()(dispatch, getState);
    }
};

module.exports = {
    getAsset,
    resetState
};
